export default "__VITE_ASSET__D5Xxrhed__"